<div class="form-wrapper-center-flex">
  <kendo-card *ngIf="!registerSuccess" [width]="'auto'">
    <kendo-card-body>
      <div>
        <form [formGroup]="registerForm" class="k-form">
          <fieldset class="k-form-fieldset">
            <legend class="k-form-legend">
              {{ "REGISTER_FORM.TITLE" | translate }}
            </legend>

            <kendo-formfield>
              <kendo-label
                [for]="bulstat"
                [text]="'REGISTER_FORM.BULSTAT' | translate"
              ></kendo-label>
              <input formControlName="Bulstat" #bulstat kendoTextBox />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                [for]="email"
                [text]="'REGISTER_FORM.EMAIL' | translate"
              ></kendo-label>
              <input formControlName="Email" #email kendoTextBox />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                [for]="password"
                [text]="'REGISTER_FORM.PASSWORD' | translate"
              ></kendo-label>
              <input
                formControlName="Password"
                #password
                type="password"
                kendoTextBox
              />
            </kendo-formfield>

            <kendo-formfield>
              <kendo-label
                [for]="controlNumber"
                [text]="'REGISTER_FORM.CONTROL_NUMBER' | translate"
              ></kendo-label>
              <input
                formControlName="ControlNumber"
                #controlNumber
                kendoTextBox
              />
            </kendo-formfield>

            <div class="recaptcha-wrapper">
              <re-captcha formControlName="Recaptcha"></re-captcha>
            </div>
          </fieldset>
        </form>
      </div>
    </kendo-card-body>
    <hr kendoCardSeparator />
    <kendo-card-actions layout="end">
      <button
        themeColor="primary"
        [disabled]="registerForm.invalid || loading"
        (click)="submit()"
        kendoButton
        fillMode="flat"
      >
        <kendo-loader size="small" *ngIf="loading"></kendo-loader>
        {{ "REGISTER_FORM.SUBMIT" | translate }}
      </button>
    </kendo-card-actions>
  </kendo-card>

  <kendo-card [width]="'auto'" *ngIf="registerSuccess">
    <kendo-card-header>
      <p kendoTypography variant="h4">
        {{ "AUTH.REGISTER_SUCCESS_TITLE" | translate }}
      </p>
    </kendo-card-header>
    <kendo-card-body>
      <p
        kendoTypography
        fontSize="lg"
        translate
        [innerHTML]="
          'AUTH.REGISTER_SUCCESS_EMAIL_MESSAGE'
            | translate: { email: registerForm.value.Email }
        "
      ></p>
    </kendo-card-body>
    <kendo-card-actions layout="end">
      <button kendoButton routerLink="/auth/login" [primary]="true">
        {{ "AUTH.LOGIN" | translate }}
      </button>
    </kendo-card-actions>
  </kendo-card>
</div>
